import { api } from '../lib/api';
import type { ChargeType, InvoiceFrequency, Order } from '../types/api';

export interface OrderLineInput {
  customerCatalogItemId: string;
  quantity: number;
  reference?: string;
}

export interface CreateOrderInput {
  siteId: string;
  reference: string;
  lines: OrderLineInput[];
}

export async function createOrder(input: CreateOrderInput): Promise<Order> {
  const { data } = await api.post<Order>('/orders', input);
  return data;
}

export async function listOrders(): Promise<Order[]> {
  const { data } = await api.get<Order[]>('/orders');
  return data;
}

export async function getApprovalQueue(): Promise<Order[]> {
  const { data } = await api.get<Order[]>('/orders/queue');
  return data;
}

export async function getOrder(id: string): Promise<Order> {
  const { data } = await api.get<Order>(`/orders/${id}`);
  return data;
}

export interface ApproveOrderInput {
  poNumber: string;
  chargeType: ChargeType;
  managedTermMonths?: number;
  managedFrequency?: InvoiceFrequency;
}

export async function approveOrder(id: string, input: ApproveOrderInput): Promise<Order> {
  const { data } = await api.patch<Order>(`/orders/${id}/approve`, input);
  return data;
}

export async function rejectOrder(id: string, reason: string): Promise<Order> {
  const { data } = await api.patch<Order>(`/orders/${id}/reject`, { reason });
  return data;
}

export interface AmendOrderInput {
  reference?: string;
  lines: OrderLineInput[];
}

export async function amendAndResubmit(id: string, input: AmendOrderInput): Promise<Order> {
  const { data } = await api.patch<Order>(`/orders/${id}/amend-resubmit`, input);
  return data;
}
